import { render } from "./ShippingMethodSites.vue?vue&type=template&id=e6afc0a0&scoped=true&ts=true"
import script from "./ShippingMethodSites.vue?vue&type=script&lang=ts"
export * from "./ShippingMethodSites.vue?vue&type=script&lang=ts"

import "./ShippingMethodSites.vue?vue&type=style&index=0&id=e6afc0a0&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6afc0a0"]])

export default __exports__